



























































































































































































































import Vue from 'vue'
import api from '@/helpers/fetch'

const SYSTEM = `Você é um advogado assistente sênior do escritório Locatelli Advogados, especializado em Direito Tributário brasileiro, com profundo conhecimento em Direito Constitucional, Societário e Cível. Experiência ampla em advocacia tributária e cultura jurídica sólida, com domínio da jurisprudência atualizada do STF, STJ, CARF e TRFs.

Seu papel é auxiliar os advogados seniores na elaboração de peças jurídicas de alta qualidade. Você deve:
- Produzir textos em linguagem jurídica formal, técnica e precisa
- Estruturar as peças com seções claras e bem delimitadas
- Citar legislação pertinente (CTN, CF/88, LC 87/96, LC 214/2024, etc.)
- Referenciar jurisprudência com número de processo quando possível
- Mencionar doutrinadores de peso quando pertinente (Paulo de Barros Carvalho, Roque Carrazza, Humberto Ávila, Sacha Calmon, etc.)
- Incorporar os dados dos documentos do cliente ao racional jurídico
- Ser direto, sem prolegômenos desnecessários

Estrutura para impugnação administrativa: Qualificação → Tempestividade → Dos Fatos → Do Direito (subteses numeradas) → Dos Pedidos.
Estrutura para mandado de segurança: Endereçamento → Dos Fatos → Do Direito → Da Liminar → Dos Pedidos.
Estrutura para parecer: Ementa → Consulta → Do Mérito (tópicos) → Conclusão.

Responda SEMPRE em português jurídico formal. Em ajustes via chat, confirme objetivamente o que foi alterado.`

export default Vue.extend({
	name: 'AssistenteJuridico',

	data() {
		return {
			folder: 'Defesas Administrativas',
			tipo: 'Impugnação Adm.',
			prompt: '',
			docs: [
				'Notificação SEFAZ 2024-004321.pdf',
				'Balanço 2023 — Cliente XYZ.xlsx',
			],
			folders: [
				{ name: 'Judicial', icon: '⚖️' },
				{ name: 'Defesas Administrativas', icon: '🏛️' },
				{ name: 'Opiniões Legais', icon: '📋' },
				{ name: 'Transações Tributárias', icon: '🤝' },
				{ name: 'Jurisprudência', icon: '📚' },
			],
			tipos: [
				'Mandado de Segurança',
				'Impugnação Adm.',
				'Recurso Voluntário',
				'Parecer',
				'Transação Tributária',
			],
			chips: [
				'Reforçar tese constitucional',
				'Mais jurisprudência STF',
				'Suavizar o tom',
				'Adicionar pedido liminar',
				'Incluir RE 574.706',
				'Linguagem mais objetiva',
			],
			hist: [] as { role: string; content: string }[],
			pecas: [] as { tipo: string; text: string; html: string }[],
			generating: false,
			progress: 0,
			chatMessages: [
				{
					role: 'assistant',
					content:
						'Bom dia. Pasta <strong>Defesas Administrativas</strong> ativa e documentos do cliente disponíveis.<br><br>Descreva o caso, gere a peça — e use este chat para ajustar tese, tom, pedidos ou citações.',
				},
			] as { role: string; content: string }[],
			chatInput: '',
			chatLoading: false,
		}
	},

	methods: {
		simUpload() {
			const name = window.prompt(
				'Nome do arquivo (simulação):',
				'Contrato Social — XYZ.pdf',
			)
			if (name) this.docs.push(name)
		},

		async gerarPeca() {
			if (!this.prompt.trim()) return
			this.generating = true
			this.progress = 0

			const iv = setInterval(() => {
				this.progress = Math.min(
					this.progress + Math.random() * 9,
					87,
				)
			}, 220)

			const userMsg = `Tipo de peça: ${this.tipo}\nPasta: ${this.folder}\nDocs do cliente: ${this.docs.join(', ')}\n\nInstruções:\n${this.prompt}`
			this.hist.push({ role: 'user', content: userMsg })

			const res = await api.post('/api/assistente-juridico', {
				system: SYSTEM,
				messages: this.hist,
			})

			clearInterval(iv)
			this.progress = 100

			if (res?.ok && res.content?.[0]?.text) {
				const text = res.content[0].text
				this.hist.push({ role: 'assistant', content: text })
				this.pecas.unshift({
					tipo: this.tipo,
					text,
					html: this.fmtPeca(text),
				})
				this.addChatMsg('assistant', `Peça elaborada (v${this.pecas.length}). Revise e use este chat para ajustes.`)
			} else {
				this.hist.pop()
				this.addChatMsg('assistant', 'Erro ao gerar a peça. Tente novamente.')
			}

			this.generating = false
		},

		async sendChat() {
			const msg = this.chatInput.trim()
			if (!msg) return
			this.chatInput = ''
			this.addChatMsg('user', msg)
			this.chatLoading = true

			const ctx = this.pecas.length
				? `Ajuste na peça elaborada. Indique o que foi alterado. Instrução: ${msg}`
				: msg

			this.hist.push({ role: 'user', content: ctx })

			const res = await api.post('/api/assistente-juridico', {
				system: SYSTEM,
				messages: this.hist,
			})

			if (res?.ok && res.content?.[0]?.text) {
				const reply = res.content[0].text
				this.hist.push({ role: 'assistant', content: reply })
				this.addChatMsg('assistant', reply)
			} else {
				this.hist.pop()
				this.addChatMsg('assistant', 'Erro ao processar. Tente novamente.')
			}

			this.chatLoading = false
		},

		addChatMsg(role: string, content: string) {
			this.chatMessages.push({ role, content })
			this.$nextTick(() => {
				const el = this.$refs.chatMsgs as HTMLElement
				if (el) el.scrollTop = el.scrollHeight
			})
		},

		fmtPeca(text: string): string {
			return text
				.split('\n')
				.map((l) => {
					const t = l.trim()
					if (!t) {
						return '<br>'
					}
					if (/^(EXCELENTÍSSIM|ILMO|MM\.|AO JUÍZO|COLENDA)/i.test(t)) {
						return `<div class="aj-ptitle">${t}</div>`
					}
					if (/^[IVX]+[\s.–—-]/.test(t) && t === t.toUpperCase()) {
						return `<div class="aj-sec">${t}</div>`
					}
					if (/^(\d+\.\s)/.test(t)) {
						const num = t.match(/^\d+\.\s/)?.[0] || ''
						return `<p><strong>${num}</strong>${t.replace(/^\d+\.\s/, '')}</p>`
					}
					return `<p>${t}</p>`
				})
				.join('')
		},

		copyPeca(peca: { text: string }) {
			navigator.clipboard.writeText(peca.text).then(() => alert('Copiado.'))
		},

		downloadPeca(peca: { tipo: string; text: string }) {
			const a = document.createElement('a')
			a.href = URL.createObjectURL(
				new Blob([peca.text], { type: 'text/plain;charset=utf-8' }),
			)
			a.download = `Locatelli_${peca.tipo.replace(/\s/g, '_')}_v${this.pecas.length}.txt`
			a.click()
		},
	},
})
